import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import { getCareerOutcomesConsumerDisclaimers } from 'bundles/unified-description-page-common/utils/careerOutcomes';

type Props = {
  pageData: ConsumerSpecializationPageFieldsFragment;
};

const ConsumerSpecializationCitationModuleRenderer = ({ pageData }: Props) => {
  if (!pageData.careerOutcomes?.careerGrowthInPercentage) return null;
  return <CitationModule removeTopPadding citations={getCareerOutcomesConsumerDisclaimers()} />;
};

export default ConsumerSpecializationCitationModuleRenderer;
